// extracted by mini-css-extract-plugin
module.exports = {"btn":"CloseButton_btn__273T8"};